import { API_LOBBY } from '../baseUrls';
import { baseApiGet } from '../baseApi';

export const translationApiGet = ({ params }) =>
  baseApiGet({
    api: API_LOBBY,
    params,
  });
